import _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reverseImmutable = <TList extends Array<any>>(array: TList): TList =>
  _.reverse(array.slice()) as TList;
